import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { 
  FaClock, FaCalendarAlt, FaStar, FaCheckCircle, FaArrowRight,
  FaBookOpen, FaCertificate, FaTrophy, FaUsers, FaHeartbeat,
  FaRupeeSign, FaAward, FaListUl
} from 'react-icons/fa';

const PageContainer = styled.div`
  margin-top: 180px;
  background: #ffffff;

  @media (max-width: 1366px) and (min-width: 769px) {
    margin-top: 155px;
  }


  @media (max-width: 768px) {
    margin-top: 120px;
  }
`;

/* ========== HERO ========== */
const HeroSection = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #3730A3 50%, #0b0b77 100%);
  color: white;
  padding: 2.5rem 5%;
  text-align: center;
`;

const HeroBadge = styled.span`
  display: inline-flex; align-items: center; gap: 0.5rem;
  background: rgba(255,255,255,0.1); padding: 0.4rem 1.2rem; border-radius: 50px;
  font-size: 0.9rem; font-weight: 600; margin-bottom: 1rem;
  svg { color: #a78bfa; }
`;

const HeroTitle = styled.h1`
font-family: 'Times New Roman', serif;
  font-size: 2.8rem; font-weight: 800; margin-bottom: 0.5rem;
  span { display: block; color: #a78bfa; font-size: 1.2rem; font-weight: 400; margin-top: 0.2rem; }
  @media (max-width: 768px) { font-size: 2rem; span { font-size: 1rem; } }
`;

const HeroDesc = styled.p`
font-family: 'Times New Roman', serif;
  font-size: 1rem; opacity: 0.85; max-width: 650px; margin: 0.5rem auto 1rem;
`;

const HeroInfo = styled.div`
  display: flex; justify-content: center; gap: 1.5rem; flex-wrap: wrap; margin-top: 1rem;
  div { display: flex; align-items: center; gap: 0.4rem; background: rgba(255,255,255,0.08); padding: 0.5rem 1rem; border-radius: 30px; font-size: 0.9rem; 
    svg { color: #a78bfa; } strong { color: #a78bfa; } }
`;

/* ========== CONTAINER ========== */
const Container = styled.div`
  max-width: 1100px; margin: 0 auto; padding: 2.5rem 5% 3rem;
`;

/* ========== LAYOUT ========== */
const TwoCol = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem; margin-bottom: 1.5rem;
  @media (max-width: 800px) { grid-template-columns: 1fr; }
`;

/* ========== CARDS ========== */
const SectionCard = styled.div`
  background: white; border-radius: 14px; padding: 1.5rem;
  border: 1px solid #f0f0f5; box-shadow: 0 2px 10px rgba(0,0,0,0.02);
`;

const CardTitle = styled.h3`
font-family: 'Times New Roman', serif;
  font-size: 1.1rem; color: #1a1a2e; font-weight: 700; margin-bottom: 1rem;
  display: flex; align-items: center; gap: 0.6rem;
  .card-icon { width: 36px; height: 36px; border-radius: 10px; background: #f5f3ff; color: #3730A3; display: flex; align-items: center; justify-content: center; font-size: 1rem; }
`;

const SimpleList = styled.ul`
font-family: 'Times New Roman', serif;
  list-style: none; padding: 0;
  li { display: flex; align-items: flex-start; gap: 0.6rem; padding: 0.4rem 0; color: #4a4a6a; font-size: 0.9rem; line-height: 1.5;
    svg { color: #3730A3; font-size: 0.85rem; margin-top: 3px; flex-shrink: 0; } }
`;

const NumberedList = styled.div`
  display: flex; flex-direction: column; gap: 0.5rem;
`;

const NumberedItem = styled.div`
font-family: 'Times New Roman', serif;
  display: flex; align-items: flex-start; gap: 0.8rem;
  .num { width: 28px; height: 28px; border-radius: 50%; background: #3730A3; color: white; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 0.8rem; flex-shrink: 0; }
  p { color: #4a4a6a; font-size: 0.9rem; line-height: 1.5; }
`;

/* ========== CURRICULUM ========== */
const CurrList = styled.div`
  display: flex; flex-direction: column; gap: 0.5rem;
`;

const CurrItem = styled.div`
font-family: 'Times New Roman', serif;
  display: flex; align-items: center; gap: 0.8rem; padding: 0.8rem 1rem;
  background: #fafbff; border-radius: 10px; border: 1px solid #f0f0f5;
  svg { color: #3730A3; font-size: 0.9rem; flex-shrink: 0; }
  span { color: #1a1a2e; font-size: 0.9rem; font-weight: 500; }
`;

/* ========== CERT BLOCK ========== */
const CertBlock = styled.div`
  background: #fff;
  border: 1px solid #f0f0f5;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

const CertHead = styled.div`
  background: #3730A3;
  padding: 1.2rem 1.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

const CertHeadTitle = styled.div`
  font-family: 'Times New Roman', serif;
  font-size: 1.1rem;
  color: #fff;
  font-weight: 800;
`;

const CertHeadBadge = styled.div`
  font-family: 'Times New Roman', serif;
  background: rgba(167, 139, 250, 0.2);
  color: #a78bfa;
  border: 1px solid rgba(167, 139, 250, 0.3);
  font-size: 0.72rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-weight: 700;
`;

const CertBody = styled.div`
  padding: 1.8rem;
`;

const CertDesc = styled.p`
  font-family: 'Times New Roman', serif;
  font-size: 0.95rem;
  color: #4a4a6a;
  line-height: 1.8;
  margin-bottom: 1.8rem;
  border-left: 3px solid #a78bfa;
  padding-left: 1.2rem;
`;

const CertCols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.8rem;

  @media (max-width: 650px) { grid-template-columns: 1fr; }
`;

const CertColTitle = styled.div`
  font-family: 'Times New Roman', serif;
  font-size: 0.78rem;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #3730A3;
  font-weight: 700;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PlainList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    font-family: 'Times New Roman', serif;
    font-size: 0.92rem;
    color: #4a4a6a;
    padding: 0.35rem 0;
    border-bottom: 1px solid #f0f0f5;
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    line-height: 1.5;

    &:last-child { border-bottom: none; }

    svg { color: #3730A3; font-size: 0.8rem; margin-top: 3px; flex-shrink: 0; }
  }
`;

const FeeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Times New Roman', serif;
  margin-bottom: 0;

  th {
    background: #1a1a2e;
    color: rgba(255,255,255,0.7);
    font-size: 0.75rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 0.7rem 1.2rem;
    text-align: left;
    font-weight: 700;
  }

  td {
    padding: 0.9rem 1.2rem;
    border-bottom: 1px solid #f0f0f5;
    font-size: 0.95rem;
    color: #4a4a6a;
  }

  tr:last-child td { border-bottom: none; }

  .amt {
    font-size: 1.5rem;
    font-weight: 900;
    color: #1a1a2e;
  }

  tr.highlight { background: #f5f3ff; }
  tr.highlight .amt { color: #3730A3; }
  tr.highlight td { border-bottom: none; }
`;

/* ========== CTA ========== */
const CTASection = styled.div`
  margin: 2rem 0 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background: #1a1a2e;
  border-radius: 14px;
  overflow: hidden;
  padding: 1.5rem 1.5rem 1.5rem 0;

  &::before {
    content: '';
    width: 5px;
    align-self: stretch;
    background: #a78bfa;
    flex-shrink: 0;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    padding: 1.5rem;
    &::before { display: none; }
  }
`;

const CTAText = styled.div`
  flex: 1;
  .cta-title {
    font-family: 'Times New Roman', serif;
    font-size: 1.4rem;
    font-weight: 800;
    color: #fff;
    margin-bottom: 0.3rem;
  }
  .cta-sub {
    font-family: 'Times New Roman', serif;
    font-size: 0.95rem;
    color: rgba(255,255,255,0.55);
    font-style: italic;
  }
`;

const CTAButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #a78bfa;
  color: #1a1a2e;
  font-family: 'Times New Roman', serif;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.8rem 1.8rem;
  border-radius: 50px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover { 
    background: #c4b5fd; 
    transform: translateY(-2px);
  }
`;

const Spacer = styled.div`
  height: 2rem;
`;

const SurgeryCoding = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const topics = [
    "Overview of U.S. Healthcare",
    "Overview of Reimbursement Methodologies",
    "ICD-10-CM Coding",
    "CPT Coding for Outpatient Surgeries",
    "Coding Surgeries with Modifiers"
  ];

  const benefits = [
    "A long-term stable career with plenty of opportunities to work anywhere in India",
    "Knowledge about coding surgical reports in the outpatient setting",
    "Track record of passing rate of more than 98% apart from Trainee Satisfaction",
    "Placement assistance provided for merit candidates"
  ];

  const whoShouldAttend = [
    "Candidates already working in outpatient settings like ED Professional/Facility, E&M coding etc., who are willing to advance their career in medical coding",
    "Candidates working in HCC Coding, who are willing to explore other options in their career",
    "Candidates who are willing to learn coding for outpatient surgeries to broaden their knowledge spectrum",
    "Candidates who are willing to move to the U.S. for employment opportunities or for any other reason"
  ];

  const curriculum = [
    "Basics of Anatomy, Terminology, and Pathophysiology",
    "Overview of U.S. Healthcare",
    "Overview of Reimbursement Methodologies",
    "Dissecting an Operative Report from Coding Perspective",
    "ICD-10 CM Coding",
    "CPT Coding for Outpatient Surgeries",
    "Surgical Package & Global Period Modifiers",
    "Practical Coding Scenarios"
  ];

  const cgscExamTopics = [
    "Ability to read and dissect operative notes to apply correct ICD-10 CM, CPT®, HCPCS Level II, and modifier coding assignment",
    "Evaluation and Management (both the 1995 and 1997 Documentation Guidelines)",
    "Rules and regulations of Medicare billing including, but not limited to, incident to teaching situations, shared visits, consultations, and global surgery",
    "Accurate coding of surgical procedures performed by general surgeons such as colonoscopies, hernia repairs, breast procedures, transplants etc.",
    "Medical terminology",
    "Anatomy and physiology"
  ];

  const inclusions = [
    '50 Hours Expert Training',
    'Study Materials & Practice Exercises',
    'Operative Report Coding Practice',
    'Mock Exams (CGSC Pattern)',
    'One-on-One Mentoring',
    'Certificate of Completion'
  ];

  return (
    <PageContainer>
      {/* HERO */}
      <HeroSection>
        <HeroBadge><FaHeartbeat /> Specialty Program</HeroBadge>
        <HeroTitle>Surgery Coding Training<span>Master Outpatient Surgical Coding</span></HeroTitle>
        <HeroDesc>
          Learn to code surgical procedures with CPT modifiers, ICD-10-CM, and prepare for the CGSC™ certification.
        </HeroDesc>
        <HeroInfo>
          <div><FaClock /> Duration: <strong>50 Hours</strong></div>
          <div><FaCalendarAlt /> <strong>8-10 Weeks</strong></div>
          <div><FaTrophy /> Pass Rate: <strong>98%</strong></div>
        </HeroInfo>
      </HeroSection>

      <Container>
        {/* ROW 1: Topics + Benefits */}
        <TwoCol>
          <SectionCard>
            <CardTitle><span className="card-icon"><FaBookOpen /></span>Topics Covered</CardTitle>
            <SimpleList>
              {topics.map((t, i) => <li key={i}><FaCheckCircle /> {t}</li>)}
            </SimpleList>
          </SectionCard>

          <SectionCard>
            <CardTitle><span className="card-icon"><FaTrophy /></span>Program Benefits</CardTitle>
            <SimpleList>
              {benefits.map((b, i) => <li key={i}><FaCheckCircle /> {b}</li>)}
            </SimpleList>
          </SectionCard>
        </TwoCol>

        {/* WHO SHOULD ATTEND */}
        <SectionCard style={{marginBottom:'1.5rem'}}>
          <CardTitle><span className="card-icon"><FaUsers /></span>Who Should Attend?</CardTitle>
          <NumberedList>
            {whoShouldAttend.map((item, i) => (
              <NumberedItem key={i}><span className="num">{i+1}</span><p>{item}</p></NumberedItem>
            ))}
          </NumberedList>
        </SectionCard>

        {/* CURRICULUM */}
        <SectionCard style={{marginBottom:'1.5rem'}}>
          <CardTitle><span className="card-icon"><FaBookOpen /></span>Course Curriculum</CardTitle>
          <CurrList>
            {curriculum.map((item, i) => (
              <CurrItem key={i}><FaCheckCircle /> <span>{item}</span></CurrItem>
            ))}
          </CurrList>
        </SectionCard>

        {/* CERTIFICATION & FEES */}
        <CertBlock>
          <CertHead>
            <CertHeadTitle>CGSC™ Certification — AAPC</CertHeadTitle>
            <CertHeadBadge>Specialty Certification</CertHeadBadge>
          </CertHead>
          <CertBody>
            <CertDesc>
              The certificate is provided by AAPC upon successful completion of the CGSC certification examination. 
              The Coders with sufficient experience and expertise in general surgery coding are encouraged to sit 
              for the <strong>Certified General Surgery Coder (CGSC™)</strong> examination that is developed by 
              a team of leading general surgery coding professionals.
            </CertDesc>

            <CertCols>
              <div>
                <CertColTitle><FaAward /> CGSC™ Exam Tests On</CertColTitle>
                <PlainList>
                  {cgscExamTopics.map((item, i) => (
                    <li key={i}><FaCheckCircle />{item}</li>
                  ))}
                </PlainList>
              </div>
              <div>
                <CertColTitle><FaListUl /> Course Inclusions</CertColTitle>
                <PlainList>
                  {inclusions.map((inc, i) => (
                    <li key={i}><FaCheckCircle />{inc}</li>
                  ))}
                </PlainList>
              </div>
            </CertCols>

            <FeeTable>
              <thead>
                <tr>
                  <th>Component</th>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="highlight">
                  <td><strong>Course Fee</strong></td>
                  <td>To be paid to LearnThruUs Academy</td>
                  <td><span className="amt">₹20,000 + GST</span></td>
                </tr>
              </tbody>
            </FeeTable>
          </CertBody>
        </CertBlock>

        {/* CTA */}
        <CTASection>
          <CTAText>
            <div className="cta-title">Ready to Master Surgery Coding?</div>
            <div className="cta-sub">Join our Surgery Coding Training and prepare for the CGSC™ certification.</div>
          </CTAText>
          <CTAButton to="/contact-us">
            Enroll Now <FaArrowRight />
          </CTAButton>
        </CTASection>

        <Spacer />
      </Container>
    </PageContainer>
  );
};

export default SurgeryCoding;